module.exports = __webpack_public_path__ + "media/images/pc/specials/fair/bg_02-b1d2c018de4caea81f07c5c83da4ae29.jpg";